import Header from "../../components/Nav/Header";
import Footer from "../../components/Nav/Footer";
import { makeStyles } from "../../styles";
import { isMobileOnly } from "react-device-detect";
import Sidebar from "../../components/Nav/Sidebar";

const useStyles = makeStyles()((theme) => ({
  contentWrapper: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
  },
  content: {
    width: "calc(100% - 76px)",
    height: "100vh",
    overflowY: "scroll",
    marginLeft: "76px",
    position: "relative",
  },
}));

const MainLayout: React.FC = ({ children }) => {
  const { classes } = useStyles();

  return (
    <>
      {/* <Header /> */}
      <div className={classes.contentWrapper}>
        <Sidebar />
        <div className={classes.content}>{children}</div>
        {/* <Footer /> */}
      </div>
    </>
  );
};

export default MainLayout;
